import SidebarImageIntro from './sidebar.png';

export const sidebarPhotoIntro = () => SidebarImageIntro;
